<template>
	<div>
    <div class="popup_high_right discount-details-popup side-popup"
         :class="['level-'+level,{inactive:!discount.is_active}]">
            <Loading v-show="loading"/>

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <h3 class="title" >
		            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
		            {{ discount.name }}
	            </h3>

	            <div class="order-status-row">
		            <span class="label">Status:</span>
		            <div class="status-tags">
			            <div class="status-tag" v-if="!discount.is_active">
				            <inline-svg class="refund" :src="require('@/assets/img/close-circle-outline.svg')"/>
				            <span class="value">Inactive</span>
			            </div>
			            <div class="status-tag" v-else>
				            <inline-svg :src="require('@/assets/img/circle-checked.svg')"/>
				            <span class="value">Active</span>
			            </div>
		            </div>

		            <span class="label">Created at:</span>
		            <span class="value">{{ localDate }}</span>
		            <div class="flex"></div>

		            <quick-actions-btn :items="[
		            		{label:'Delete discount',disabled:false,icon:require('@/assets/img/cross.svg')}]"
		                               @menuClick="menuClick" :loading="discountMenuLoading" />
	            </div>

	            <div class="layout-column margin-t-25" style="position: relative">
		            <div>
			            <input-field label="Name" placeholder="eg. CODE20OFF..." required v-model="discount.name" />
		            </div>
		            <div>
			            <v-switch class="margin-t-25" :value="discount.is_active"
			                      v-model="discount.is_active" label="Is active?" />
		            </div>
		            <div class="layout-column margin-t-15">
			            <label class="label">Type</label>
			            <div class="layout-row">
				            <select-button no-icon label="Percentage" value="percentage" v-model.number="discount.type" class="margin-r-15"  />
				            <select-button no-icon label="Fixed" value="fixed" v-model.number="discount.type"  />
			            </div>
		            </div>
		            <div class="layout-column margin-t-25">
			            <!--				<label class="label">Value</label>-->
			            <div class="" style="width: 400px">
				            <input-field v-if="discount.type==='percentage'" label="Discount percentage" type="number" :min="0" :max="100"
				                         required v-model.number="discount.value" append="%" />

				            <input-field v-else label="Discount value" type="number" :min="0"
				                         :info="valueInfo"
				                         required v-model.number="discount.value" :prepend="currency" >
				            </input-field>
			            </div>
		            </div>

		            <expandable-area title="Settings" tag="(optional)" name="create_discount.settings" class="margin-t-25">
			            <date-picker date-label="Start date" :min-date="minStartDate"
			                         time-label="Start time" v-model="discount.start_time" />

			            <v-switch label="Has end date?" class="margin-t-25"
			                      :value="hasEndDate" v-model="hasEndDate" @change="hasEndDateChanged($event)" />
			            <date-picker v-if="hasEndDate" :min-date="minEndDate"
			                         date-label="End date" time-label="End time" v-model="discount.end_time" />
		            </expandable-area>

	            </div>

	            <div style="min-height: 50px"></div>
            </div>
	    <div class="layout-row popup-actions">
		    <v-button label="Save changes" :loading="saving" @click="save" :disabled="!discount.name||!discount.value" />
		    <v-button label="Cancel" border @click="closePopup" />
	    </div>
        </div>

		<popup-backdrop v-if="deleteDiscountOpen" @close="deleteDiscountOpen=false">
			<delete-discount :level="level+1" :discount="discount"
			              @close="deleteDiscountOpen=false" @done="deleteDiscountOpen=false;$emit('close')" />
		</popup-backdrop>

	</div>
</template>

<script>
import API from "@/api"
import countries from "@/helpers/countries"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import {getSymbol} from "@/helpers/currencies";
import numbers from "@/helpers/numbers";
import ExpandableArea from "@/components/base/expandable-area";
import moment from "moment";
import CustomerEntry from "@/views/orders/customer-entry";
import OrderTimeline from "@/views/orders/order-timeline";
import OrderNotes from "@/views/orders/order-notes";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import CancelOrder from "@/views/orders/cancel-order";
import FulfillOrder from "@/views/orders/fulfill-order";
import OrderFulfillment from "@/views/orders/order-fulfillment";
import AddTrackingInfo from "@/views/orders/add-tracking-info";
import DeleteOrder from "@/views/orders/delete-order";
import {mapGetters} from "vuex";
import {getGatewayById} from "@/helpers/gateways";
import RefundOrder from "@/views/orders/refund-order";
import OrderSummary from "@/views/orders/order-summary";
import DatePicker from "@/components/base/date-picker";
import VSwitch from "@/components/base/v-switch";
import SelectButton from "@/components/base/select_button";
import DeleteDiscount from "@/views/store/delete-discount";

export default {
	name: "discount-details-popup",
	title: "Discount details | Funnelish™",
	mixins: [API],
	components: {
		DeleteDiscount,
		SelectButton,
		VSwitch,
		DatePicker,
		OrderSummary,
		RefundOrder,
		DeleteOrder,
		AddTrackingInfo,
		OrderFulfillment,
		FulfillOrder,
		CancelOrder,
		QuickActionsBtn,
		BackBtn,
		PopupBackdrop,
		CustomerDetailsNew: ()=>import("@/views/customers/customer-details-new"),
		OrderNotes,
		OrderTimeline,
		CustomerEntry,
		ExpandableArea,
		SelectField,
		InputField,
		InfoIcon,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		discountId:{
			type: Number,
		},
		level: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			hasEndDate:false,
			discountMenuLoading: false,
			deleteDiscountOpen: false,
			saving: false,
			loading: true,
			discount: {
				is_active: false,
				name: '',
				value: 0,
				type: 'percentage',
				max_uses: -1,
			},
		}
	},
	computed:{
		...mapGetters(['getDiscountsStore']),
		localDate(){
			return moment(this.discount.created_at).format("DD MMMM YYYY, HH:mm:ss")
		},
		valueInfo(){
			return `The currency will be changed to the one of the funnel
								if it's different from <b>${this.currency}</b>. The discount value will not be converted.`
		},
		currency(){
			return getSymbol(this.$store.state.userInfo.default_currency_code)
		},
		minStartDate() {
			return moment()
		},
		minEndDate() {
			return moment.utc(this.discount.start_time).local()
		},
	},
	methods: {
		hasEndDateChanged(b) {
			if (b) {
				this.discount.end_time = moment.utc(this.discount.start_time).local().add(30, 'day')
			}
			else
				this.discount.end_time = null
		},

		menuClick(e){
			if (e.action==='Delete discount') {
				this.deleteDiscountOpen = true;
			}
		},
		roundPrice(n) {
			return numbers.round_to_two(n)
		},
		closePopup() {
			this.$emit('close')
		},
		async save(){
			try {
				this.saving = true;

				let discount = await this.api.discounts.update(this.discount);
				if (discount.error) this.$error(discount.error);
				else {
					let i = this.getDiscountsStore.findIndex(x=>x.id===this.discount.id);
					if (i>=0) {
						this.getDiscountsStore.splice(i, 1, JSON.parse(JSON.stringify(this.discount)))
					}
					this.closePopup();
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		},
		async init() {
			try {
				this.loading = true;
				this.discount = {};

				this.discount = await this.api.discounts.get(this.discountId);
				if (this.discount) {
					this.discount.start_time = moment.utc(this.discount.start_time).local()
					if (this.discount.end_time) {
						this.discount.end_time = moment.utc(this.discount.end_time).local()
						this.hasEndDate = true
					}
				}
				// this.$store.dispatch("setCurrentOrder", this.order)
			} catch (e) {
				this.$error(e);
			} finally {
				this.loading = false;
			}
		},
	},
	created() {
		this.init();
	},
}
</script>
<style lang="scss" scoped>
.discount-details-popup {
	padding: 0;
	&.archived {
		.title {
			color: $dark-grey;
		}
	}
	&.canceled {
		.title {
			text-decoration: line-through;
		}
	}
	.status-tags {
		display: flex;
		flex-direction: row;
		margin-right: 25px;
	}
	.status-tag {
		border-radius: 5px;
		background: $light-silver;
		padding: 3px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.value {
			margin: 0 0 0 5px;
		}
		svg {
			//color: #18d7ae;
			height: 18px;
			&.refund {
				color: $black;
			}
		}
		margin-right: 3px;
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.order-status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
